export default __webpack_public_path__ + "static/media/travel_logo_250.200c5183.jpg";